import axios from "axios";
import AppContext from "../../../context/AppContext";
import { useContext } from "react";
import { Container, Card, Button } from "react-bootstrap";
import { ShieldCheck, CheckCircleFill } from "react-bootstrap-icons";
import "../../../assets/css/Drivers/DriverKyc/IdentityVerification.css";

const IdentityVerification = () => {
    const { baseUrl, authToken } = useContext(AppContext);

    const handleVerify = () => {
        axios.post(`${baseUrl}/general/kyc/createInquiry`, {},
            {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            }).then((response) => {
                const inquiryId = response.data.inquiry_id;
                window.location.href =
                    `https://inquiry.withpersona.com/verify?inquiry-id=${inquiryId}&redirect-uri=https://trustidrive.btsportfolio2026.com/vehicle-upload`;
            })
            .catch((error) => {
                console.log(error);
                alert("Unable to start identity verification.");
            });
    };
    return (

        <div className="iv-wrapper">

            <Container>
            {/* Back Button */}
            <button
                className="iv-card__back-btn"
                onClick={() => window.history.back()}
                aria-label="Go back"
            >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M19 12H5M12 5l-7 7 7 7" />
                </svg>
            </button>

                <Card className="iv-card text-center">

                    <ShieldCheck size={70} className="iv-icon mx-auto" />

                    <h2 className="iv-title">
                        Identity Verification
                    </h2>

                    <p className="iv-subtitle">
                        Verify your identity securely with Persona.
                    </p>

                    <div className="iv-list">

                        <div className="iv-item">
                            <CheckCircleFill className="iv-check" />
                            National ID / CNIC
                        </div>

                        <div className="iv-item">
                            <CheckCircleFill className="iv-check" />
                            Driving License
                        </div>

                        <div className="iv-item">
                            <CheckCircleFill className="iv-check" />
                            Face Verification
                        </div>

                    </div>

                    <Button
                        className="iv-btn"
                        onClick={handleVerify}
                    >
                        Verify with Persona
                    </Button>

                </Card>

            </Container>

        </div>

    );

};

export default IdentityVerification;